/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  if (customElements.get('featured-rail')) return;

  class FeaturedRail extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.thumb = this.querySelector('[data-rail-progress]');
      if (!this.rail) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.onResize();

      var finePointer = window.matchMedia('(pointer: fine)').matches;
      var motionOn = document.documentElement.classList.contains('motion');
      if (finePointer && motionOn) this.enableDrag();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.momentumFrame) cancelAnimationFrame(this.momentumFrame);
    }

    onResize() {
      var max = this.rail.scrollWidth - this.rail.clientWidth;
      var progress = this.thumb ? this.thumb.parentElement : null;
      if (progress) progress.classList.toggle('is-hidden', max < 8);
      if (this.thumb && max >= 8) {
        this.thumbRatio = this.rail.clientWidth / this.rail.scrollWidth;
        this.thumb.style.width = Math.max(this.thumbRatio * 100, 8) + '%';
      }
      this.onScroll();
    }

    onScroll() {
      var max = this.rail.scrollWidth - this.rail.clientWidth;
      var p = max > 0 ? this.rail.scrollLeft / max : 0;

      this.rail.style.setProperty('--fade-start', p > 0.02 ? 1 : 0);
      this.rail.style.setProperty('--fade-end', p < 0.98 && max > 0 ? 1 : 0);

      if (this.thumb && max > 0) {
        var trackWidth = this.thumb.parentElement.clientWidth;
        var thumbWidth = this.thumb.offsetWidth;
        this.thumb.style.transform = 'translateX(' + p * (trackWidth - thumbWidth) + 'px)';
      }
    }

    enableDrag() {
      var self = this;
      var rail = this.rail;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      var lastX = 0;
      var lastT = 0;
      var velocity = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (rail.scrollWidth <= rail.clientWidth) return;
        dragging = true;
        moved = false;
        startX = lastX = e.clientX;
        lastT = performance.now();
        startScroll = rail.scrollLeft;
        velocity = 0;
        if (self.momentumFrame) cancelAnimationFrame(self.momentumFrame);
        rail.setPointerCapture(e.pointerId);
      });

      rail.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          rail.classList.add('is-dragging');
        }
        if (!moved) return;
        rail.scrollLeft = startScroll - dx;

        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastT = now;
      });

      var release = function (e) {
        if (!dragging) return;
        dragging = false;
        try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
        if (!moved) return;

        setTimeout(function () { rail.classList.remove('is-dragging'); }, 0);
        self.momentum(velocity);
      };
      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);

      rail.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    momentum(velocity) {
      var self = this;
      var rail = this.rail;
      var v = -velocity * 16;
      if (Math.abs(v) < 1) return;
      var step = function () {
        rail.scrollLeft += v;
        v *= 0.94;
        var max = rail.scrollWidth - rail.clientWidth;
        if (Math.abs(v) > 0.5 && rail.scrollLeft > 0 && rail.scrollLeft < max) {
          self.momentumFrame = requestAnimationFrame(step);
        }
      };
      this.momentumFrame = requestAnimationFrame(step);
    }
  }

  customElements.define('featured-rail', FeaturedRail);
})();
